module.exports = __webpack_public_path__ + "img/gentlemen-club-carousel-23.706a1e5a.png";